import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Article from "./pages/Article";
import Calendar from "./pages/Calendar";
import EventDetail from "./pages/EventDetail";
import Experiences from "./pages/Experiences";
import Concierge from "./pages/Concierge";
import Propose from "./pages/Propose";
import Admin from "./pages/Admin";
import DuotoneFilter from "./components/DuotoneFilter";
import { I18nProvider } from "./i18n";

export default function App() {
  return (
    <div className="App">
      <DuotoneFilter />
      <BrowserRouter>
        <I18nProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/journal/:id" element={<Article />} />
              <Route path="/calendario" element={<Calendar />} />
              <Route path="/calendario/:id" element={<EventDetail />} />
              <Route path="/experiencias" element={<Experiences />} />
              <Route path="/concierge" element={<Concierge />} />
              <Route path="/proponer" element={<Propose />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
          </Routes>
        </I18nProvider>
      </BrowserRouter>
      <Toaster position="top-right" toastOptions={{ style: { background: "#F5EBD8", color: "#1A1613", border: "1px solid #1F3A6E", borderRadius: 0 } }} />
    </div>
  );
}
